module.exports = __webpack_public_path__ + "static/media/peach_compote.45ef0238.png";